import { Link } from "react-router-dom";
import { Rocket, Shield, Lock, Key, Server, FileCheck, UserCheck, AlertTriangle } from "lucide-react";

import { _t } from "@/lib/i18n";
import { LegalTranslationNotice } from "@/components/LanguageSwitcher";
function Nav() {
  return (
    <header className="glass-header sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3"><Rocket className="w-5 h-5 text-[#FF5722] -rotate-45" /><div className="font-display text-2xl text-white">{_t("Time Capsule")}</div></Link>
        <nav className="hidden md:flex items-center gap-2 text-sm">
          <Link to="/come-funziona" className="px-3 py-2 text-white/70 hover:text-white">{_t("Come funziona")}</Link>
          <Link to="/prezzi" className="px-3 py-2 text-white/70 hover:text-white">{_t("Prezzi")}</Link>
          <Link to="/sicurezza" className="px-3 py-2 text-[#FF5722]">{_t("Sicurezza")}</Link>
          <Link to="/faq" className="px-3 py-2 text-white/70 hover:text-white">{_t("FAQ")}</Link>
        </nav>
        <div className="flex gap-3"><Link to="/login" className="btn-ghost">{_t("Accedi")}</Link><Link to="/register" className="btn-launch">{_t("Inizia")}</Link></div>
      </div>
    </header>
  );
}

export default function Security() {
  const items = [
    { icon: <Lock />, title: _t("Cifratura in transito e a riposo"), body: _t("TLS end-to-end e cifratura a riposo dei file su object storage. Nessun contenuto esposto pubblicamente.") },
    { icon: <Key />, title: _t("Autenticazione sicura"), body: _t("Password protette con bcrypt, sessioni via cookie httpOnly + JWT. In roadmap: 2FA opzionale.") },
    { icon: <Shield />, title: _t("Autorizzazioni server-side"), body: _t("Ogni azione verifica i permessi lato server: il mittente non può accedere ai contenuti dopo il sigillo; il destinatario solo alla data.") },
    { icon: <Server />, title: _t("URL firmati e temporanei"), body: _t("I file sono raggiungibili solo tramite endpoint autenticati; nessun link diretto e permanente ai contenuti.") },
    { icon: <FileCheck />, title: _t("Integrità garantita"), body: _t("Ogni capsula ha un hash SHA-256 dei contenuti che ne certifica l'immutabilità dopo il sigillo.") },
    { icon: <UserCheck />, title: _t("Audit log"), body: _t("Ogni creazione, modifica, lancio, annullamento, consegna, apertura è registrata in un log immutabile.") },
    { icon: <AlertTriangle />, title: _t("Rate limiting e validazioni"), body: _t("Protezione da abuso, validazione lato server di tutti i dati, controllo tipi di file caricati.") },
  ];
  return (
    <div className="min-h-screen">
      <Nav />
      <section className="max-w-5xl mx-auto px-6 py-24">
        <LegalTranslationNotice />
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5722] mb-4">{_t("Sicurezza & Privacy")}</div>
        <h1 className="font-display text-6xl md:text-7xl text-white leading-tight mb-6">{_t("I tuoi ricordi, custoditi con cura.")}</h1>
        <p className="text-lg text-white/70 max-w-2xl mb-16">{_t("Time Capsule tratta i tuoi contenuti come i tuoi. Nessuna pubblicità, nessuna cessione. Solo custodia.")}</p>

        <div className="grid md:grid-cols-2 gap-4 mb-16">
          {items.map((it, i) => (
            <div key={i} className="tc-card p-6">
              <div className="w-10 h-10 rounded-full bg-[#FF5722]/15 border border-[#FF5722]/30 flex items-center justify-center text-[#FF5722] mb-4">{it.icon}</div>
              <div className="font-display text-2xl text-white mb-2">{it.title}</div>
              <div className="text-sm text-white/60 leading-relaxed">{it.body}</div>
            </div>
          ))}
        </div>

        <div className="tc-card p-8 mb-8">
          <div className="font-display text-3xl text-white mb-3">{_t("Trasparenza sulla durata")}</div>
          <p className="text-white/70 leading-relaxed">{_t("Non promettiamo conservazione eterna. Vedrai sempre in modo chiaro: il tuo piano, le condizioni di rinnovo, la scadenza dell'archiviazione e le modalità di esportazione dei tuoi dati. Il tuo diritto GDPR alla portabilità è garantito.")}</p>
        </div>
        <div className="tc-card p-8">
          <div className="font-display text-3xl text-white mb-3">{_t("Contatto fiduciario")}</div>
          <p className="text-white/70 leading-relaxed">{_t("Potrai (feature in roadmap) designare un contatto fiduciario che, dopo verifiche puntuali, potrà gestire le tue capsule in caso di eventi eccezionali. Nessuna verifica legale simulata: solo procedure reali e documentate.")}</p>
        </div>
      </section>
    </div>
  );
}
